<div class="wrap">
  <ng-container *ngIf="pageState === pageStates.SCANNING">
    <app-scanner class="scanner"></app-scanner>
    <app-svg-icon
      [name]="'close'"
      [color]="'color-on-primary'"
      class="close-icon"
      (click)="onCloseModal()"
    ></app-svg-icon>
    <div class="hint">
      {{ "@pages.orderConfirmationScanner.hint" | translate }}
    </div>
  </ng-container>

  <ng-container *ngIf="pageState === pageStates.CHECKING">
    <div class="content">
      <ion-spinner class="app-spinner"></ion-spinner>
    </div>
  </ng-container>

  <ng-container
    *ngIf="
      pageState === pageStates.ERROR || pageState === pageStates.WRONG_BARCODE
    "
  >
    <div class="content">
      <div class="center">
        <app-svg-icon
          class="icon"
          [name]="'info'"
          [color]="'color-state-error'"
        ></app-svg-icon>
        <div class="message error-message">
          {{
            "@pages.orderConfirmationScanner.errorMessages." + pageState
              | translate
          }}
        </div>
      </div>
      <app-action-button
        [label]="'@pages.orderConfirmationScanner.tryAgainBtn' | translate"
        (click)="onTryAgainClick()"
      ></app-action-button>
    </div>
  </ng-container>

  <ng-container *ngIf="pageState === pageStates.COMPLETE">
    <div class="content">
      <div class="center">
        <app-svg-icon
          class="icon"
          [name]="'info'"
          [color]="'color-state-success'"
        ></app-svg-icon>
        <div class="message success-message">
          {{ "@pages.orderConfirmationScanner.successMessage" | translate }}
        </div>
      </div>
      <app-action-button
        [label]="'@pages.orderConfirmationScanner.finishBtn' | translate"
        (click)="onFinishClick()"
      ></app-action-button>
    </div>
  </ng-container>
</div>
